// extracted by mini-css-extract-plugin
export var callCard = "_ql-0";
export var callMessageButton = "_ql-1";
export var helpIcon = "_ql-3";
export var helpIconContainer = "_ql-4";
export var verticalDivider = "_ql-2";